// @flow
import React from 'react';
import moment, { type Moment } from 'moment-timezone';
import range from 'lodash/range';
import SortableTableColumnHeader from './SortableTableColumnHeader';
import { Row, GridHeaderCell } from './Grid';
import { AVAILABILITY_DAYS_TO_DISPLAY } from '../../constants';

type PropTypes = {
    divisionType: string,
    hasAreaData: boolean,
    onNameSortToggle: (boolean, boolean, string) => void,
    onAreaSortToggle: (boolean, boolean, string) => void,
    onCodeSortToggle: (boolean, boolean) => void,
    sort: { column: string, isAsc: boolean, isSorted: boolean },
    startDate: Moment,
    numOfCols?: number,
};

function AvailabilityTableHeader({
    divisionType,
    hasAreaData,
    sort,
    startDate,
    onNameSortToggle,
    onAreaSortToggle,
    onCodeSortToggle,
    numOfCols = AVAILABILITY_DAYS_TO_DISPLAY,
}: PropTypes) {
    return (
        <Row>
            {hasAreaData && (
                <SortableTableColumnHeader
                    name="ID"
                    isSorted={sort.column === 'code' ? sort.isSorted : false}
                    isAsc={sort.column === 'code' ? sort.isAsc : false}
                    onSortToggle={onCodeSortToggle}
                />
            )}
            <SortableTableColumnHeader
                id={divisionType}
                name={divisionType}
                isSorted={sort.column === 'name' ? sort.isSorted : false}
                isAsc={sort.column === 'name' ? sort.isAsc : false}
                onSortToggle={onNameSortToggle}
            />
            {hasAreaData && (
                <SortableTableColumnHeader
                    id="Area"
                    name="Area"
                    isSorted={sort.column === 'district' ? sort.isSorted : false}
                    isAsc={sort.column === 'district' ? sort.isAsc : false}
                    onSortToggle={onAreaSortToggle}
                />
            )}
            {range(numOfCols).map((i) => {
                const dt = moment(startDate).add(i, 'day');
                return (
                    <GridHeaderCell key={i} aria-disabled="true">
                        <div>
                            <span className="rec-sr-only">
                                {dt.format('dddd, MMMM D, YYYY')}
                            </span>
                            <span className="weekday" aria-hidden>
                                {dt.format('ddd')}
                            </span>
                            <span className="date" aria-hidden>
                                {dt.format('D')}
                            </span>
                        </div>
                    </GridHeaderCell>
                );
            })}
        </Row>
    );
}

export default React.memo<PropTypes>(AvailabilityTableHeader);
